import { createBrowserHistory } from 'history'

// Create browser history to use in the Redux store
const history = createBrowserHistory()

export default history



// WEBPACK FOOTER //
// ./src/utils/history.js